module.exports = __webpack_public_path__ + "static/media/farmers_market_fruit.3778f653.jpeg";